/* tslint:disable:no-console */
// This file gets environment variables with guards in case they are not set
let REACT_APP_SEGMENT_API_KEY = undefined;
let REACT_APP_DISABLE_SEGMENT = undefined;
let REACT_APP_BUGSNAG_API_KEY = undefined;
let REACT_APP_BUGSNAG_RELEASE_STAGE = undefined;
let REACT_APP_DISABLE_BUGSNAG = undefined;
let GOLDEN_GATE = undefined;
let STACK = undefined;
let NODE_ENV = undefined;
let env;
const getEnv = () => {
  if (!env) {
    try {
      REACT_APP_SEGMENT_API_KEY = process.env.REACT_APP_SEGMENT_API_KEY;
    } catch (ex) {}
    try {
      REACT_APP_DISABLE_SEGMENT = process.env.REACT_APP_DISABLE_SEGMENT;
    } catch (ex) {}
    try {
      REACT_APP_BUGSNAG_API_KEY = process.env.REACT_APP_BUGSNAG_API_KEY;
    } catch (ex) {}
    try {
      REACT_APP_BUGSNAG_RELEASE_STAGE =
        process.env.REACT_APP_BUGSNAG_RELEASE_STAGE;
    } catch (ex) {}
    try {
      REACT_APP_DISABLE_BUGSNAG = process.env.REACT_APP_DISABLE_BUGSNAG;
    } catch (ex) {}
    try {
      GOLDEN_GATE = process.env.REACT_APP_GOLDEN_GATE === "true";
    } catch (ex) {}
    // Set GOLDEN_GATE for non-appshell projects
    try {
      if (GOLDEN_GATE === undefined) {
        if (window.location.hostname.indexOf(".autodesk.") >= 0) {
          GOLDEN_GATE = true;
        }
      }
    } catch (ex) {
      GOLDEN_GATE = false;
    }
    try {
      STACK = process.env.STACK;
    } catch (ex) {}
    // Conditionally set STACK for non-appshell projects
    try {
      if (STACK === undefined) {
        const { hostname } = window.location;
        if (hostname === "localhost" || hostname.indexOf("local.") >= 0) {
          STACK = "local";
        } else if (hostname.indexOf("acc.autodesk.") >= 0) {
          STACK = "prod-gg";
        } else if (hostname.indexOf("acc-staging.") >= 0) {
          STACK = "test-gg";
        } else {
          STACK = "dev-gg";
        }
      }
    } catch (ex) {}
    try {
      if (["development", "test", "production"].includes(process.env.NODE_ENV))
        NODE_ENV = process.env.NODE_ENV;
      else throw new Error("NODE_ENV is set to an unrecognized value.");
    } catch (ex) {}
    try {
      const local = /^local/i;
      if (NODE_ENV === undefined && !local.test(window.location.hostname)) {
        // Set NODE_ENV for non-appshell projects
        NODE_ENV = "production";
      } else if (
        NODE_ENV === "production" &&
        local.test(window.location.hostname)
      ) {
        // Prevent Cypress production builds from sending events
        // Anything other than "production" will not send events
        NODE_ENV = "development";
      }
    } catch (ex) {
      NODE_ENV = "development";
    }
    env = {
      REACT_APP_BUGSNAG_API_KEY,
      REACT_APP_BUGSNAG_RELEASE_STAGE,
      REACT_APP_DISABLE_BUGSNAG,
      REACT_APP_SEGMENT_API_KEY,
      REACT_APP_DISABLE_SEGMENT,
      GOLDEN_GATE,
      STACK,
      NODE_ENV,
    };
  }
  return env;
};
export { getEnv };
